<script setup>
import { computed, ref, watch } from 'vue'
import { domainToProfileIdOptionsMap } from '@/contentprofile/domain_content_profiles'
import { useUserStore } from '@/authentication/user.store'
import { storeToRefs } from 'pinia'
import { useVisibilityStore } from '@/visibility/visibility.store'

const userStore = useUserStore()
const visibilityStore = useVisibilityStore()
const { userDomainUuid } = storeToRefs(userStore)
const { canChangeProfile } = storeToRefs(visibilityStore)

const props = defineProps({
  profileChoices: {
    type: Array,
    required: true
  },
  currentlyActiveProfileId: {
    type: String,
    required: true
  }
})

const selectedProfileId = ref(props.currentlyActiveProfileId)

const isDirty = computed(() => {
  return props.currentlyActiveProfileId !== selectedProfileId.value
})

const profilesWithLabels = computed(() => {
  return profilesForDomain.value.map((p) => ({ ...p, label: p.name, value: p.id }))
})

const profilesForDomain = computed(() => {
  if (!canChangeProfile.value) {
    return props.profileChoices
  }

  const profileIdOptions = domainToProfileIdOptionsMap[userDomainUuid.value]
  if (!profileIdOptions) {
    return props.profileChoices
  }

  const filteredProfileChoices = props.profileChoices.filter((p) => profileIdOptions.includes(p.id))

  if (filteredProfileChoices.length === 0) {
    return props.profileChoices
  }
  return filteredProfileChoices
})

const isConfirmEnabled = computed(() => {
  return (selectedProfileId.value && isDirty.value) || false
})

const emit = defineEmits(['contentprofile:confirmEnabled', 'contentprofile:changed'])

watch(isConfirmEnabled, (newVal) => {
  emit('contentprofile:confirmEnabled', newVal)
})

watch(selectedProfileId, (newVal) => {
  emit('contentprofile:changed', newVal)
})

watch(() => props.currentlyActiveProfileId, (newVal) => {
  selectedProfileId.value = newVal
})
</script>
<template>
  <p v-if="canChangeProfile">Your state profile is indicated below. Use the dropdown menu to switch to a different state.</p>
  <p v-else>Your content profile is indicated below. Use this form to switch to a different profile.</p>
    <label for="content-profile-select" class="block text-base font-bold leading-6 text-gray-800">{{ canChangeProfile ? 'State' : 'Content Profile' }}</label>
  <select
    id="content-profile-select"
    v-model="selectedProfileId"
    class="mt-1 block w-full h-8 px-3 text-sm leading-5 text-gray-800 bg-gray-100 border border-gray-500 rounded focus:outline-none focus:ring-0 focus:border-gray-600 hover:bg-gray-200 rounded-md"
  >
    <option v-for="profile in profilesWithLabels" :key="profile.value" :value="profile.value">
      {{ profile.label }}
    </option>
  </select>
</template>
